export const competitorsList = `
query Competitors($sport: ID, $search: String, $tournamentCategory: ID) {
    competitorsForDropdown(filters: {
        search: $search
        sport: $sport
        tournamentCategory: $tournamentCategory
    })
}`;

export const avCompetitorsList = `
query avCompetitors($search: String) {
    avCompetitors(filters : {
                search: $search
    }) {
        id: id
        value: id
        text: name
    }
}`;
